/* eslint-disable no-undef */

import Auth from '../auth'
import api from '@/services/api'
import { apiErrorHandler } from '../utils/apiErrors'

const PAYMENTS_ENDPOINT = 'payments/'

export default class PaymentsAPI {
  /**
   * Instantiate a new `PaymentsAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `PaymentsAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new PaymentsAPI(cls)
  }

  /* Get the API Client. */
  get client() {
    return api.getApiClient()
  }

  get(paymentId) {
    const url = `${PAYMENTS_ENDPOINT}${paymentId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  create(payment) {
    const url = PAYMENTS_ENDPOINT
    const data = this.cls.toAPI(payment)

    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Create update API error' }))
  }

  update(payment, fields = [], excludeFields = []) {
    const url = `${PAYMENTS_ENDPOINT}${payment.id}/`
    let data = this.cls.toAPI(payment, fields, excludeFields)

    return this.client
      .patch(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Update payment Profile Data API error' }))
  }

  /**
   * Get List of payments via the API.
   *
   * @param {object} pagination - Pagination parameters for the API.
   * @param {object} filters - Filter parameters for the API.
   *
   * @returns {Promise} - Contains the list of `Payment` instances.
   */
  list({ filters = {} } = {}) {
    const authHeader = Auth.getAuthorizationHeader()
    const url = PAYMENTS_ENDPOINT
    const options = {
      headers: {
        ...authHeader,
      },
      params: {},
    }

    if (filters.pageSize) {
      options.params.page_size = filters.pageSize
    }

    if (filters.payout) {
      options.params.payout = filters.payout
    }

    if (filters.id) {
      options.params.name = filters.name
    }

    if (filters.page) {
      options.params.page = filters.page
    }

    if (filters.status) {
      options.params.status = filters.status
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => ({
        ...data,
        results: data.results.map(this.cls.fromAPI),
      }))
      .catch(apiErrorHandler({ apiName: 'Updates API error' }))
  }

  updateStatus(payment, status) {
    const url = `${PAYMENTS_ENDPOINT}${payment.id}/update-status/`
    const authHeader = Auth.getAuthorizationHeader()
    const data = {
      status: status,
    }

    const options = {
      headers: {
        ...authHeader,
      },
    }
    return this.client
      .post(url, data, options)
      .then(response => response.data)
      .catch(apiErrorHandler({ apiName: 'API error' }))
  }
}
